<template>
    <el-drawer :visible.sync="dialogFormVisible" size="90%" append-to-body @close="handleClose">
        <b slot="title" class="text-info">#{{single.id}}){{single.subject}}</b>
        <div class="w-100 h-100 d-flex" style="flex-direction: column;align-content: space-between">
            <div class="px-3" style="flex: 1 1 0;overflow-y: auto;overflow-x: hidden">

                <div v-for="x in single.items" :key="x.id">
                    <b>{{x.order}}) {{x.question}}</b>
                    <div v-if="x.answer_type == 1" class="">
                        <div v-for="a in toArray(x.answers)" :key="a"
                             style="display: inline-block;padding: 5px 20px;">
                            <label><input type="checkbox" :name="'question_'+x.id"/> {{a}}</label>
                        </div>
                    </div>
                    <div v-else class="">
                        <div v-for="a in toArray(x.answers)" :key="a"
                             style="display: inline-block;padding: 5px 20px;">
                            <label>
                                <input type="radio" :name="'question_'+x.id"/> {{a}}
                            </label>
                        </div>
                    </div>
                    <div class="mb-3"></div>
                </div>
                <div>
                    <div class="line my-3"></div>
                    <div class="mb-4">
                        <el-checkbox v-model="assign_mode" label="清除原有投票后再添加" v-if="show_meeting" true-label="1"
                                     false-label="0"></el-checkbox>
                        <br/>
                        <el-select v-model="select_meeting" clearable class="ml-3 w-100"
                                   placeholder="请输入关键字查询,选择需要添加到的会议" v-if="show_meeting"
                                   filterable
                                   remote
                                   :remote-method="remoteMethod"
                                   :loading="process.loading">
                            <el-option v-for="x in meetings" :key="x.id" :value="x.id" :label="x.label"></el-option>
                        </el-select>
                    </div>
                </div>

            </div>

            <div class="px-3" style="flex: 0 0 50px">
                <el-button type="primary" @click="dialogFormVisible=false" class="pull-right"
                           :loading="process.loading">关 闭
                </el-button>
                <el-button type="warning" @click="handleAssign" v-if="show_meeting" :loading="process.loading">添加至会议
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>

    import PollReviewMixin from "../common/mixins/poll-review-mixin"

    export default {
        name: "poll-review",
        data() {
            return {}
        },
        mixins: [PollReviewMixin],
    }
</script>

<style lang="scss" scoped>
</style>
